export default {
    data() {
        return {
            inactivityTimeout: 30 * 60 * 1000,
            lastInteractionTime: new Date().getTime(),
            inactivityInterval: null,
        };
    },
    methods: {
        updateLastInteractionTime() {
            this.lastInteractionTime = new Date().getTime();
        },
        checkInactivity() {
            const currentTime = new Date().getTime();
            const elapsedTime = currentTime - this.lastInteractionTime;

            if (elapsedTime > this.inactivityTimeout) {
                this.handleInactivity();
            }
        },
        startInactivityCheck() {
            this.inactivityInterval = setInterval(this.checkInactivity, 60 * 1000);
            this.updateLastInteractionTime();
        },
        handleInactivity() {
            const routesWithoutLogout = [
                '/relatorio/metas',
                '/relatorio/dashboard-executivo-eficiencia-comercial',
                '/relatorio/painel-eficiencia-comercial-leads',
                '/relatorio/dashboard-gerencial-eficiencia-comercial',
                '/relatorio/wilson-micai',
                '/relatorio/wagner-castilho',
                '/relatorio/marcio-almeida',
                '/relatorio/rodrigo-jubett',
                '/relatorio/daniela-cipriano',
                '/relatorio/anderson-vianna',          
            ]

            const currentPath = this.$router?.history?.current?.path

            if (!routesWithoutLogout.includes(currentPath)) {
                this.$router.push('/login')
                sessionStorage.clear()
            }

            clearInterval(this.inactivityInterval);
        },
    },
    mounted() {
        document.addEventListener('mousemove', this.updateLastInteractionTime);
        document.addEventListener('keydown', this.updateLastInteractionTime);
        document.addEventListener('click', this.updateLastInteractionTime);

        this.startInactivityCheck();
    },
    beforeDestroy() {
        clearInterval(this.inactivityInterval);
        document.removeEventListener('mousemove', this.updateLastInteractionTime);
        document.removeEventListener('keydown', this.updateLastInteractionTime);
        document.removeEventListener('click', this.updateLastInteractionTime);
    },
};
